import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { Alert, Empty, Muted, PageHeader, Section } from '@/components/ui'
import { fetchOrganograma } from './api'
import type { OrganogramaNo } from './types'

function OrgNode({ node, depth = 0 }: { node: OrganogramaNo; depth?: number }) {
  const filhos = node.filhos || []
  return (
    <li>
      <div className="card hi-row" style={{ marginLeft: depth * 12 }}>
        <div className="hi-row-main">
          <strong>{node.nome}</strong>
          <span>
            {node.gestor ? `Gestor: ${node.gestor}` : 'Sem gestor'}
            {node.headcount != null ? ` · HC ${node.headcount}` : ''}
          </span>
        </div>
      </div>
      {filhos.length > 0 ? (
        <ul className="hi-list" style={{ marginTop: 8 }}>
          {filhos.map((f, i) => (
            <OrgNode key={f.id || `${f.nome}-${i}`} node={f} depth={depth + 1} />
          ))}
        </ul>
      ) : null}
    </li>
  )
}

export function OrganogramaPage() {
  const org = useQuery({
    queryKey: ['rh', 'organograma'],
    queryFn: fetchOrganograma,
  })

  const raiz = org.data
  const filhos = raiz?.filhos || []

  return (
    <section className="hi-page">
      <PageHeader
        title="Organograma"
        subtitle="Árvore de departamentos via API. Visual interativo e organograma operacional no legado."
        actions={
          <a className="btn btn-secondary" href={legacyAppUrl('#/organograma-vivo')}>
            Legado
          </a>
        }
      />

      {org.isLoading ? <Muted>Carregando…</Muted> : null}
      {org.isError ? (
        <Alert tone="danger">
          {org.error instanceof ApiError ? org.error.message : 'Falha ao carregar organograma.'}
        </Alert>
      ) : null}

      {raiz ? (
        <Section title={raiz.nome || 'Empresa'} flush>
          {filhos.length === 0 ? (
            <Empty>Nenhum departamento raiz cadastrado.</Empty>
          ) : (
            <ul className="hi-list">
              {filhos.map((n, i) => (
                <OrgNode key={n.id || `${n.nome}-${i}`} node={n} />
              ))}
            </ul>
          )}
        </Section>
      ) : null}
    </section>
  )
}

export default OrganogramaPage
